export var NET_TYPES = ['wifi', '2g', '3g', '4g'];
export var FROG_STATUS = {
    INIT: 0,
    SENDING: 1,
    SUCCESS: 2,
    FAILED: 3,
};
export var TIMEOUT = 5000;
export var HTTP_ERROR = {
    STATUS_ERROR: 'statusError',
    TIMEOUT: 'timeout',
    ABORT: 'abort',
    ERROR: 'error',
};
